export default "__VITE_ASSET__1HfFowOQ__"